"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotificationWrapper = exports.NotificationHeader = exports.IconWrapper = exports.ContentWrapper = exports.CloseButton = exports.ButtonWrapper = exports.AlertNotification = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _coreMixins = require("@vfuk/core-mixins");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var AlertNotification = _styledComponents["default"].div.withConfig({
  displayName: "AlertNotificationstyle__AlertNotification",
  componentId: "sc-1jx5ywu-0"
})(function () {
  return (0, _styledComponents.css)(["display:flex;flex-direction:column;"]);
});
exports.AlertNotification = AlertNotification;
var IconWrapper = _styledComponents["default"].div.withConfig({
  displayName: "AlertNotificationstyle__IconWrapper",
  componentId: "sc-1jx5ywu-1"
})(function (props) {
  return (0, _styledComponents.css)(["background:", ";display:flex;"], props.theme.color[props.state]["default"]);
});
exports.IconWrapper = IconWrapper;
var NotificationHeader = _styledComponents["default"].div.withConfig({
  displayName: "AlertNotificationstyle__NotificationHeader",
  componentId: "sc-1jx5ywu-2"
})(function (props) {
  var iconSize = props.theme.getIconProperties('system').size[2].sm;
  return (0, _styledComponents.css)(["flex:1;text-align:center;margin-left:", ";margin-bottom:0;", ""], props.closeButton ? "".concat(iconSize, "px") : '0', (0, _coreMixins.advancedSpacing)('padding', [2, 2, 2]));
});
exports.NotificationHeader = NotificationHeader;
var ContentWrapper = _styledComponents["default"].div.withConfig({
  displayName: "AlertNotificationstyle__ContentWrapper",
  componentId: "sc-1jx5ywu-3"
})(function () {
  return (0, _styledComponents.css)(["", " display:flex;flex-direction:column;flex:1;"], (0, _coreMixins.advancedSpacing)('padding', [3]));
});
exports.ContentWrapper = ContentWrapper;
var NotificationWrapper = _styledComponents["default"].div.withConfig({
  displayName: "AlertNotificationstyle__NotificationWrapper",
  componentId: "sc-1jx5ywu-4"
})(function () {
  return (0, _styledComponents.css)(["width:100%;display:flex;"]);
});
exports.NotificationWrapper = NotificationWrapper;
var CloseButton = _styledComponents["default"].div.withConfig({
  displayName: "AlertNotificationstyle__CloseButton",
  componentId: "sc-1jx5ywu-5"
})(function () {
  return (0, _styledComponents.css)(["", " padding:0;"], (0, _coreMixins.advancedSpacing)('margin', [3, 3, 1]));
});
exports.CloseButton = CloseButton;
var ButtonWrapper = _styledComponents["default"].div.withConfig({
  displayName: "AlertNotificationstyle__ButtonWrapper",
  componentId: "sc-1jx5ywu-6"
})(function () {
  return (0, _styledComponents.css)(["", ""], _coreMixins.respondTo.md((0, _styledComponents.css)(["margin-left:auto;"])));
});
exports.ButtonWrapper = ButtonWrapper;